import type { AdminCrewReportVesselTableProps } from "../../models/admin-crew-report.models";
import {
  ADMIN_CREW_REPORT_VESSEL_LIST_MAX_HEIGHT,
  ADMIN_CREW_REPORT_VESSEL_ROW_HEIGHT,
  getAdminCrewReportVesselKey,
} from "../../utils/admin-crew-report.utils";
import { CheckIcon } from "@heroicons/react/24/outline";
import { Virtuoso } from "react-virtuoso";
import { twMerge } from "tailwind-merge";

const AdminCrewReportVesselTable = ({ vessels, selectedVessel, onSelectVessel }: AdminCrewReportVesselTableProps) => {
  if (vessels.length === 0) {
    return <div className="px-3 py-4 text-sm text-gray-500 dark:text-gray-400">No matching active vessels.</div>;
  }

  const selectedVesselKey = selectedVessel ? getAdminCrewReportVesselKey(selectedVessel) : undefined;
  const listHeight = Math.min(
    vessels.length * ADMIN_CREW_REPORT_VESSEL_ROW_HEIGHT,
    ADMIN_CREW_REPORT_VESSEL_LIST_MAX_HEIGHT,
  );

  return (
    <div>
      <div className="grid grid-cols-[minmax(140px,2fr)_minmax(80px,1fr)_minmax(80px,1fr)_minmax(100px,1.2fr)_32px] gap-3 border-b border-[#D7E2DE] px-3 py-2 text-xs font-semibold text-[#4A5655] dark:border-gray-700 dark:text-gray-300">
        <div>Vessel</div>
        <div>Code</div>
        <div>IMO</div>
        <div>Type</div>
        <div />
      </div>
      <Virtuoso
        data={vessels}
        style={{ height: listHeight }}
        fixedItemHeight={ADMIN_CREW_REPORT_VESSEL_ROW_HEIGHT}
        computeItemKey={(_, vessel) => getAdminCrewReportVesselKey(vessel)}
        itemContent={(_, vessel) => {
          const isSelected = getAdminCrewReportVesselKey(vessel) === selectedVesselKey;

          return (
            <button
              type="button"
              className={twMerge(
                "grid h-[58px] w-full grid-cols-[minmax(140px,2fr)_minmax(80px,1fr)_minmax(80px,1fr)_minmax(100px,1.2fr)_32px] items-center gap-3 px-3 py-2 text-left text-xs text-gray-900 hover:bg-[#E9F4F3] dark:text-gray-100 dark:hover:bg-gray-800",
                isSelected && "bg-[#F1FAF8] text-green dark:bg-teal-950/40",
              )}
              onClick={() => onSelectVessel(vessel)}
            >
              <span className="min-w-0 truncate font-semibold" title={vessel.vesselName}>
                {vessel.vesselName}
              </span>
              <span className="min-w-0 truncate" title={vessel.vesselCode}>
                {vessel.vesselCode}
              </span>
              <span className="min-w-0 truncate" title={vessel.imoNumber}>
                {vessel.imoNumber}
              </span>
              <span className="min-w-0 truncate" title={vessel.vesselType || "Not available"}>
                {vessel.vesselType || "Not available"}
              </span>
              <span className="flex h-6 w-6 items-center justify-center">
                {isSelected && <CheckIcon className="h-4 w-4 stroke-[3]" />}
              </span>
            </button>
          );
        }}
      />
    </div>
  );
};

export default AdminCrewReportVesselTable;
